import script from "./suspendedMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./suspendedMenu.vue?vue&type=script&setup=true&lang=js"

import "./suspendedMenu.vue?vue&type=style&index=0&id=585cf4d0&lang=scss&scoped=true"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-585cf4d0"]])

export default __exports__